import '@emotion/react';

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const getInternalFileInputStyles = process.env.NODE_ENV === "production" ? {
  name: "eivff4",
  styles: "display:none"
} : {
  name: "1y40nji-getInternalFileInputStyles",
  styles: "display:none;label:getInternalFileInputStyles;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkZpbGVJbnB1dFN0eWxlcy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFFMEMiLCJmaWxlIjoiRmlsZUlucHV0U3R5bGVzLnRzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgY3NzIH0gZnJvbSAnQGVtb3Rpb24vcmVhY3QnO1xuXG5leHBvcnQgY29uc3QgZ2V0SW50ZXJuYWxGaWxlSW5wdXRTdHlsZXMgPSBjc3Moe1xuICAgIGRpc3BsYXk6ICdub25lJyxcbn0pO1xuIl19 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};

export { getInternalFileInputStyles };
//# sourceMappingURL=FileInputStyles.js.map
